// extracted by mini-css-extract-plugin
export default {"statistic-menu":"statistic-menu--qmKbK","statisticMenu":"statistic-menu--qmKbK","title":"title--f5bkr","counter":"counter--KsEDi","line":"line--jVOr_"};